import MarchSavingsStartupLarge from 'assets/images/savings-account/march-savings-account-promo-desktop.png'
import MarchSavingsStartupSmall from 'assets/images/savings-account/march-savings-account-promo-mobile.png'
import MarchSavingsStartupMedium from 'assets/images/savings-account/march-savings-account-promo-tablet.png'
import SavingsStartupLarge from 'assets/images/savings-account/savings-account-promo-desktop.png'
import SavingsStartupSmall from 'assets/images/savings-account/savings-account-promo-mobile.png'
import SavingsStartupMedium from 'assets/images/savings-account/savings-account-promo-tablet.png'

type GetSavingsStartupImageArgs = {
  isMobile: boolean
  isMobileOrTablet: boolean
  isSavingsAccountMarchFeatureFlagOn: boolean
}

export const getSavingsStartupImage = ({
  isMobile,
  isMobileOrTablet,
  isSavingsAccountMarchFeatureFlagOn,
}: GetSavingsStartupImageArgs) => {
  if (isMobile) {
    return [
      isSavingsAccountMarchFeatureFlagOn
        ? MarchSavingsStartupSmall
        : SavingsStartupSmall,
    ]
  }

  if (isMobileOrTablet) {
    return [
      isSavingsAccountMarchFeatureFlagOn
        ? MarchSavingsStartupMedium
        : SavingsStartupMedium,
    ]
  }

  return [
    isSavingsAccountMarchFeatureFlagOn
      ? MarchSavingsStartupLarge
      : SavingsStartupLarge,
  ]
}
